<template>
  <div v-tooltip="tooltip" class="status-indicator" :class="indicator +' '+ size">
    <img v-if="status === 'hired'" src="@/assets/job-status-hired.svg" />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'is-16'
    }
  },
  computed: {
    tooltip () {
      let text = ''
      const date = moment(this.date).format('DD MMM YY')
      switch (this.status) {
        case 'offered':
          text = `Job offer: ${date} • Go to<br />the job page to view the offer`
          break
        case 'hired':
          text = `Hired: ${date}`
          break
        case 'rejected':
          text = `Rejected: ${date}`
          break
      }
      return text
    },
    indicator () {
      let cssClass = ''
      switch (this.status) {
        case 'hired':
          cssClass = 'status-hired has-border'
          break
        case 'rejected':
          cssClass = 'status-rejected has-border'
          break
        case 'offered':
          cssClass = 'status-offered has-border'
          break
      }
      return cssClass
    }
  }
}
</script>

<style lang="scss" scoped>
  .status-indicator {
    position:absolute;
    right: 0;
    top: 0;

    &.has-border {
      border: 2px solid #fff;
    }

    &.is-16 {
      width: 16px;
      height: 16px;
      border-radius: 8px;

      svg {
        font-size: 8px;
        color: #fff;
        position: absolute;
        left: 1.5px;
        top: 1.5px;
      }
    }
    &.is-24 {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      right: 4px;
      top: -5px;

      svg {
        font-size: 12px;
        color: #fff;
        position: absolute;
        left: 4px;
        top: 4px;
      }
    }
  }
  .status-hired {
    background: #44c7f0;
  }
  .status-rejected {
    background: #F54B5E;
  }
  .status-offered {
    background: #44c7f0;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-status-indicator.vue